<script>
  import appConfig from '@src/app.config'
  import Loader from '@components/inpage-loading.vue'
  import { mapGetters } from 'vuex'
  export default {
    page: {
      // All subcomponent titles will be injected into this template.
      titleTemplate (title) {
        title = typeof title === 'function' ? title(this.$store) : title
        return title ? `${title} | ${appConfig.title}` : appConfig.title
      },
    },
    components: { Loader },
    data: () => ({
      loading: true,
    }),
    computed: {
      ...mapGetters({
        authFetching: 'auth/fetching',
        reportFetching: 'report/fetching',
      }),
    },
    watch: {
      authFetching (fetching) {
        return fetching ? (this.loading = true) : (this.loading = false)
      },
      reportFetching (fetching) {
        return fetching ? (this.loading = true) : (this.loading = false)
      },
    },
    created () {
      this.loading = true
    },
    mounted () {
      this.loading = false
    },
  }
</script>

<template>
  <div id="app">
    <loader v-if="loading" />
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <transition name="fade">
      <RouterView :key="$route.fullPath" />
    </transition>
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern
// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
// Style loading bar between pages.
// Design variables and utilities from src/design.
@import '@design';

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  background: #fff;
  overflow-x: hidden;
}
#app {
  background: #fafafa;
}

// ===
// Base element styles
// ===

a,
a:visited {
  color: $color-link-text;
}
</style>
